export const isMobile =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
  window.matchMedia('only screen and (max-width: 700px)').matches

export const removeExtraSpace = (str: string) => str.replace(/\s+/g, ' ').trim()

export const isVerticalMobile = () => isMobile && (window.orientation == 0 || window.orientation == 180)

export const splitFullName = (fullName: string) => {
  let firstName = ''
  let lastName = ''
  if (fullName) {
    fullName = removeExtraSpace(fullName)
    const arr = fullName.split(' ')
    if (arr.length > 0) {
      if (arr.length > 1) {
        lastName = (arr.pop() || '').trim()
        const ind = fullName.indexOf(lastName)
        if (ind > -1) {
          firstName = fullName.substring(0, ind).trim()
        }
      } else {
        firstName = (arr[0] || '').trim()
      }
    }
  }
  return [firstName, lastName]
}

export const combineToFullName = (firstName?: string, lastName?: string) => {
  return `${firstName || ''}${firstName ? ' ' : ''}${lastName || ''}`
}
